import * as React from "react";
const SvgDownload01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1.965 16.2V15a1.035 1.035 0 0 1 2.07 0v1.2c0 .857 0 1.438.037 1.886.036.436.1.656.177.807.188.37.489.67.858.858.151.077.37.141.807.177.448.036 1.029.037 1.886.037h8.4c.857 0 1.438 0 1.886-.037.436-.036.656-.1.807-.177.37-.188.67-.489.858-.858.077-.151.141-.37.177-.807.036-.448.037-1.029.037-1.886V15a1.035 1.035 0 0 1 2.07 0v1.2c0 .823 0 1.503-.045 2.055-.046.564-.145 1.086-.395 1.577a4.03 4.03 0 0 1-1.763 1.763c-.491.25-1.013.35-1.577.395-.552.045-1.232.045-2.055.045H7.8c-.823 0-1.503 0-2.055-.045-.564-.046-1.086-.145-1.577-.395a4.03 4.03 0 0 1-1.763-1.763c-.25-.491-.35-1.013-.395-1.577-.045-.552-.045-1.232-.045-2.055m9-13.2a1.035 1.035 0 0 1 2.07 0v9.502l3.234-3.233a1.034 1.034 0 1 1 1.462 1.462l-5 5a1.034 1.034 0 0 1-1.462 0l-5-5A1.034 1.034 0 1 1 7.73 9.27l3.234 3.233z"
}));
export default SvgDownload01;
//# sourceMappingURL=Download01.js.map